import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { modelosColumns } from './columns/_columns'
import { ModeloList } from '../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const ModelosTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => modelosColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.titulo.trim()
          ? `Nenhum modelo encontrado para “${filters.titulo.trim()}”`
          : 'Nenhum modelo nesta situação'
      }
      description='Revise o título digitado ou a situação selecionada.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum modelo cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro modelo de documento.'
    />
  )

  return (
    <CustomTable<ModeloList>
      id='kt_table_modelos'
      ariaLabel={t('modelo.plural')}
      itemLabel={{ singular: t('modelo.label.lowercase'), plural: t('modelo.plural.lowercase') }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
